import React, { useState } from "react";
import "./BookForm.css";
import { FaPhone } from "react-icons/fa6";
import { IoLocationSharp } from "react-icons/io5";
import img9 from "./Images/imgt.jpg";
import { useNavigate } from "react-router-dom";

const BookForm = () => {
  const adminEmail = "tushitasingh@gmail.com";
  const adminEmail2 = "bombaydentalcompany@gmail.com";

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [isLoading, setisLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const sendEmailToAdmin = async (adminEmail) => {
    const adminEmailPayload = {
      mailto: adminEmail,
      subject: "New Appointment Request",
      body: `
New Appointment Request Details:

Patient Information:
----------------
Name: ${formData.name}
Email: ${formData.email}
Phone: ${formData.phone}

Message/Reason for Visit:
----------------
${formData.message}


This is an automated notification from the Bombay Dental Company website appointment system.
Please contact the patient to confirm their appointment time and date.
      `,
    };

    return fetch(
      "https://mimagtech.com/bombaydentalcompany/bombaydentalcompanyapi/send_mail.php",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(adminEmailPayload),
      }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setisLoading(true);

    try {
      // First API call to send form data
      await fetch(
        "https://mimagtech.com/bombaydentalcompany/bombaydentalcompanyapi/send_us.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      // Send emails to both admins
      const adminEmails = [adminEmail, adminEmail2];
      await Promise.all(adminEmails.map((email) => sendEmailToAdmin(email)));

      // Send confirmation email to user
      const userEmailPayload = {
        mailto: formData.email,
        subject: "Appointment Received",
        body: `Dear ${formData.name},

We have received your appointment request and are currently processing it. Here are the details you provided:

Name: ${formData.name}
Email: ${formData.email}
Phone: 088826 72980
Message: ${formData.message}

Thank you for reaching out to us!

Best regards,
Bombay Dental Company

Address:
Flat No 2 (12, Atur House, 1st Floor,
87, Dr Annie Besant Rd, Worli Naka,
Worli, Mumbai, Maharashtra 400018

Phone: 088826 72980`,
      };

      await fetch(
        "https://mimagtech.com/bombaydentalcompany/bombaydentalcompanyapi/send_mail.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(userEmailPayload),
        }
      );
      navigate("/thank-you");
      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
      });
    } catch (error) {
      console.error("Error processing request:", error);
      window.alert(
        "There was an issue processing your request. Please try again or call us directly."
      );
    } finally {
      setisLoading(false);
    }
  };

  return (
    <section className="form-section">
      <div className="form-container">
        <div className="form-grid">
          <div className="form-image">
            <div className="image-wrapper2">
              <img src={img9} alt="ContactUs" className="image" />
              <h1 className="image-text">
                <FaPhone color="#0047AB" />
                <p className="call">
                  <a href="tel:+918882672980">088826 72980</a>
                </p>
              </h1>

              <h1 className="image-text2">
                <IoLocationSharp color="#0047AB" />{" "}
                <p className="call">
                  Bombay Dental company Atur House First Floor, Flat no 2 Worli
                  Naka, Worli Mumbai 400018
                </p>
              </h1>
            </div>
          </div>

          <div className="form-box">
            <h2 className="form-title">Book An Appointment</h2>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="form-input"
                placeholder="Name"
                required
              />
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="form-input"
                placeholder="Email"
                required
              />
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="form-input"
                placeholder="Phone"
                required
              />
              <input
                type="text"
                name="message"
                value={formData.message}
                onChange={handleChange}
                className="form-input"
                placeholder="Message"
              />
              <button
                disabled={isLoading}
                style={{
                  cursor: isLoading ? "not-allowed" : "pointer",
                }}
                type="submit"
                className="form-button"
              >
                {isLoading ? "Sending..." : "Send"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookForm;
